export const toSelectOption = (data) => {
  if (!data || data === 'Error') return data;

  return data.map(({ id, name }) => ({
    key: id,
    value: id,
    content: name,
    search: name,
  }));
};

export const toStringIds = (data) => {
  if (!data || data === 'Error') return data;

  return new Set(data.map(({ id }) => `${id}`));
};
